import React from 'react';
import { ReactComponent as ArrowIcon } from '../../../images/arrow-right.svg';
import './primary-custom-button.styles.scss';

const PrimaryCustomButton = ({
  onClick,
  label,
  title,
  customClass,
  btndisabled,
  id,
  style,
  href, // new prop for link
  target // optional: to open in new tab
}) => {
  const classNames = customClass
    ? `primary-button ${customClass}`
    : 'primary-button';

  if (href) {
    return (
      <a
        href={href}
        className={classNames}
        id={id}
        style={style}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      >
        {label || title}
        {/* Optional Arrow Icon */}
        {/* <ArrowIcon /> */}
      </a>
    );
  }

  return (
    <button
      className={classNames}
      id={id}
      disabled={btndisabled}
      onClick={onClick}
      style={style}
    >
      {label || title}
      {/* Optional Arrow Icon */}
      {/* <ArrowIcon /> */}
    </button>
  );
};

export default PrimaryCustomButton;
